import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

require('./card-skeleton.component.scss');
@Component({
  standalone: false,
  selector: 'app-card-skeleton',
  templateUrl: './card-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardSkeletonComponent {
  @Input() rows = 8;

  public get skeletonRows(): undefined[] {
    return Array.from({length: this.rows});
  }
}
